import { TRootState } from 'Redux/Reducers';

export const isUserLoggedIn = (state: TRootState) => !!state.user.currentUser;
